import { CSSProperties } from "react";
import Colors from "modules/Colors";
import { clsx, styx } from "modules/Utils";
import Sty from "modules/Sty";
import useAdmin from "Hooks/useAdmin";

interface AdminIdProps {
    className: string;
    style?: CSSProperties;
    id?: string | number | null | undefined;
    color?: string;
    size?: number;
    label?: string;
}

const AdminId = ({
    className,
    style,
    id,
    color = Colors.greyDark,
    size = 12,
    label,
}: AdminIdProps) => {
    const {
        showIds,
    } = useAdmin();

    if (!id || !showIds) {
        return null;
    }

    return (
        <div
            className={clsx('adminIdElement', className)}
            style={styx(
                sty.adminIdElement,
                {
                    fontSize: size,
                    color,
                },
                style
            )}
        >
            {label ?
                `${label}: ${id}`
                :
                id
            }
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    adminIdElement: {
        ...Sty.text12,
        color: Colors.white,
        fontFamily: 'monospace',
    },
}

export default AdminId;